import React from "react";
import * as subscriptionService from "../actions/subscription.actions";
import {
  CONTACT_PAGE,
  HOME_PAGE,
  INFORMATION_PAGE,
  SERVER_DOWN,
  SUBSCRIPTION_PAGE,
  TERMS_AND_CONDITIONS_PAGE,
} from "../Constants";
import { useUser } from "../context/UserContext";

export default function Navigation() {
  const [user] = useUser();

  const homePage = () => {
    window.location.href = HOME_PAGE;
  };
  const contactPage = () => {
    window.location.href = CONTACT_PAGE;
  };

  const getSubcriptionPage = () => {
    if (user && user.subscription_type !== "none") {
      manageSubscriptionPage();
    } else {
      window.location.href = SUBSCRIPTION_PAGE;
    }
  };

  const manageSubscriptionPage = async () => {
    const response = await subscriptionService.manageSubscription();

    if (!response) {
      console.log(SERVER_DOWN);
      return;
    }

    if (response.data.success) {
      window.open(response.data.url);
    }
  };

  return (
    <div className="nav-wrapper">
      <div id="nav">
        <h2 className="paddingtop20 nav-link" onClick={homePage}>
          Home
        </h2>

        <h2 className="paddingtop20 nav-link" onClick={getSubcriptionPage}>
          Subscription
        </h2>

        <h2
          className="paddingtop20 nav-link"
          onClick={() => {
            window.location.href = INFORMATION_PAGE;
          }}
        >
          Information
        </h2>

        <h2 className="paddingtop20 nav-link" onClick={contactPage}>
          Contact
        </h2>

        <h2
          className="paddingtop20 nav-link"
          onClick={() => {
            window.location.href = TERMS_AND_CONDITIONS_PAGE;
          }}
        >
          T&C
        </h2>
      </div>
      <div className="nav-icons">
        <h2>
          <i className="paddingtop20 fa-left-padding fa fa-home"></i>
        </h2>

        <h2>
          <i class="paddingtop20 fa-left-padding fa-solid fa-pen-to-square"></i>
        </h2>

        <h2>
          <i className="paddingtop20 fa-left-padding fas fa-info-circle"></i>
        </h2>

        <h2>
          <i className="paddingtop20 fa-left-padding far fa-address-book"></i>
        </h2>

        <h2>
          <i className="paddingtop20 fa-left-padding fas fa-signature"></i>
        </h2>
      </div>
    </div>
  );
}
